import React, { useEffect, useState } from "react";
import QuestPost from "../../components/QuestPreview/QuestPost";
import Footer from "../../components/Footer/Footer";
import { useParams, Link } from "react-router-dom";

const QuestPage = () => {
  const { slug } = useParams();
  const [questData, setQuestData] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/questsManifest.json")
      .then((res) => res.json())
      .then((data) => {
        const quest = data.find((q) => q.slug === slug);
        setQuestData(quest);
      });
  }, [slug]);

  if (!questData) {
    return (
      <main style={{ minHeight: "60vh", padding: "2rem" }}>
        <div style={{ textAlign: "center", color: "var(--text)" }}>
          Loading quest...
        </div>
      </main>
    );
  }

  return (
    <main>
      <div style={{ maxWidth: 900, margin: "2rem auto 0 auto", padding: "0 2rem" }}>
        <Link
          to="/projects"
          style={{
            color: "var(--accent)",
            textDecoration: "none",
            fontFamily: "'Crimson Text', serif",
            fontSize: "1rem",
          }}
        >
          ← Back to all quests
        </Link>
      </div>
      <QuestPost
        file={process.env.PUBLIC_URL + questData.file}
        questData={questData}
      />
      <Footer />
    </main>
  );
};

export default QuestPage;
